import React from 'react';
import { Alert } from 'react-bootstrap';

const VolunteerHelpInfo = () => {
  return (
    <Alert dismissible variant='secondary'>
      Volunteer will be assigned to help you. If you do not see any information on this page four days prior to your arrival, please email Jason Chen at jasonchenatlanta@gmail.com.
    </Alert>
  );
};

export default VolunteerHelpInfo;